module.exports = __webpack_public_path__ + "img/ywbk07.42f0e445.jpg";